import { BaseModel } from './base';

export class ActionPermissionLevel extends BaseModel {
  actionPermissionLevelId: string;
  actionPermissionLevelName: string;
  SubscriberId: string;
  SiteId: string;
  Status: string;
  id: string;
}